import AccuType from '@/App/tiles/TargetAccumulator/AccuType.tsx';
import EkiDown from '@/App/tiles/TargetAccumulator/EkiDown.tsx';
import EkiTrigger from '@/App/tiles/TargetAccumulator/EkiTrigger';
import EkiUp from '@/App/tiles/TargetAccumulator/EkiUp.tsx';
import Pivot from '@/App/tiles/TargetAccumulator/Pivot.tsx';
import Strike from '@/App/tiles/TargetAccumulator/strike.tsx';
import StrikeDown from '@/App/tiles/TargetAccumulator/strikeDown.tsx';
import StrikeUp from '@/App/tiles/TargetAccumulator/strikeUp.tsx';
import Target from '@/App/tiles/TargetAccumulator/Target.tsx';
import { useTargetAccumulatorSelector } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import TargetProfitType from '@/App/tiles/TargetAccumulator/TargetProfitType.tsx';

export const InputGroup2 = () => {
  const accuType = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.accuType ?? 'TargetAccu',
  );

  return (
    <>
      <AccuType />

      {(accuType === 'TargetAccu' || accuType === 'EKI') && <Strike />}
      {accuType === 'EKI' && <EkiTrigger />}
      {accuType === 'PIVOTEKI' && <EkiDown />}
      {(accuType === 'PIVOT' || accuType === 'PIVOTEKI') && (
        <>
          <StrikeDown />
          <Pivot />
          <StrikeUp />
        </>
      )}
      {accuType === 'PIVOTEKI' && <EkiUp />}

      <TargetProfitType />
      <Target />
    </>
  );
};
